import { APIClient } from "../../../../api/api_helper";
import { Sponsor_API } from "../../../../api/url_helper";
import { GetUserData,CurrentUser } from "../../../../common/service/CommonService";
import { SponsorFormValues } from "modules/Library/Sponsor/helper/sponsor.types";

const api = new APIClient();

export const sponsorApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const payload = {
      status: "A",
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(Sponsor_API.Sponsor_API + "SelectAll", payload);
  },

  insertData: (payload_data: SponsorFormValues) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      sponsorname: payload_data.sponsorname,
      sponsoraddress: payload_data.sponsoraddress,
      sponsorcontact: payload_data.sponsorcontact,
      sponsoremail: payload_data.sponsoremail,
      croname: payload_data.croname,
      crocontact: payload_data.crocontact,
      croemail: payload_data.croemail,
      createdby: user.userid,
    };
    return api.create(Sponsor_API.Sponsor_API + "Insert", payload);
  },

  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      sponsorid: payload_data.sponsorId || payload_data.sponsorid,
      sponsorname: payload_data.sponsorname,
      sponsoraddress: payload_data.sponsoraddress,
      sponsorcontact: payload_data.sponsorcontact,
      sponsoremail: payload_data.sponsoremail,
      croname: payload_data.croname,
      crocontact: payload_data.crocontact,
      croemail: payload_data.croemail,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(Sponsor_API.Sponsor_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: { sponsorid: number; updatereason: string }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      sponsorid: payload_data.sponsorid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(Sponsor_API.Sponsor_API + "Delete", payload);
  },
};